import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { WooComponentsModule } from '@scripts/woo_components.module/module';
import { DotLoader } from '@src/shared/feedback/loader/dot-loader.component';
import { ProgressContentComponent } from '@src/shared/presentational/progress-content/progress-content.component';
import { EstimatesList } from './components/estimates-list.component';
import { ImportEstimates } from './components/import-estimates.component';
import { EstimateImportService } from './services/EstimateImportService';
import { EstimateValidationErrorService } from './services/EstimateValidationErrorService';

@NgModule({
  imports: [CommonModule, FormsModule, WooComponentsModule, DotLoader, ProgressContentComponent],
  providers: [EstimateImportService, EstimateValidationErrorService],
  declarations: [ImportEstimates, EstimatesList],
  exports: [ImportEstimates],
})
export class WooEstimates {}
